import * as LucideIcons from "lucide-react";

/**
 * Resolve a lucide-react icon by name (string).
 * Returns a fallback icon if the name is missing or not found.
 */
export function resolveIcon(name, fallback = "Circle") {
    if (!name) return LucideIcons[fallback] || LucideIcons.Circle;
    return LucideIcons[name] || LucideIcons[fallback] || LucideIcons.Circle;
}

/**
 * Merge a CMS-fetched list with a base array, keyed by `id`.
 * - Preserves the base item's unserialized fields (e.g. icon components).
 * - CMS values override labels, hints, colors, etc.
 * - Order follows the CMS list (so admin can re-order via CMS list editor).
 *
 * If CMS item doesn't exist in base, the item is kept as-is (icon stays a string
 * which consumers may resolve with resolveIcon).
 */
export function mergeListById(baseList, cmsList) {
    if (!Array.isArray(cmsList) || cmsList.length === 0) return baseList;
    const baseMap = new Map(baseList.map((b) => [b.id, b]));
    return cmsList.map((ci) => {
        const base = baseMap.get(ci.id);
        return base ? { ...base, ...ci } : ci;
    });
}
